<template>
  <form class="formLayout">
    <div class="formLayout__item">
      <div class="option">
        <p class="option__label">Namn</p>
        <div class="option__input">
          <div class="input">
            <input class="input__field input__field--disabled" type="text" :value="this.$store.state.user.name" disabled="disabled" />
          </div>
        </div>
      </div>
    </div>
    <div class="formLayout__item formLayout__item--half">
      <div class="option">
        <p class="option__label">Personnummer</p>
        <div class="option__input">
          <div class="input">
            <input class="input__field input__field--disabled" type="text" :value="`${this.$store.state.user.ssn} - ****`" disabled="disabled" />
          </div>
        </div>
      </div>
    </div>
    <div class="formLayout__item formLayout__item--half">
      <div class="option">
        <p class="option__label">Kundnummer</p>
        <div class="option__input">
          <div class="input">
            <input class="input__field input__field--disabled" type="text" :value="`${this.$store.state.user.customerId}****`" disabled="disabled" />
          </div>
        </div>
      </div>
    </div>
    <div class="formLayout__item">
      <div class="option">
        <p class="option__label">Bank</p>
        <div class="option__input">
          <div class="input input--dropdown">
            <select class="input__field" v-model="bank" @change="bankHandler">
              <option value="">Välj bank</option>
              <option value="OEB">Danske Bank</option>
              <option value="SHB">Handelsbanken</option>
              <option value="ICA">ICA Banken</option>
              <option value="LFB">Länsförsäkringar Bank</option>
              <option value="NB">Nordea</option>
              <option value="SEB">SEB</option>
              <option value="SKB">SkandiaBanken</option>
              <option value="SYD">Sparbanken Syd</option>
              <option value="FSPA">Swedbank</option>
              <option value="AAB">Ålandsbanken</option>
            </select>
          </div>
        </div>
        <p class="option__error" v-if="this.hasError">Du måste välja bank</p>
      </div>
    </div>
    <div class="formLayout__item formLayout__item--btn">
      <input type="hidden" :value="this.$store.state.user.id" disabled="disabled" />
      <button :class="['btn btn--wide', {'isLoading': this.isPosting}]" @click.prevent="submitPost()">Bekräfta beställning</button>
    </div>
  </form>
</template>

<script>
import { HTTP } from '@/helpers/http-common'

export default {
  name: 'Form',
  data () {
    return {
      bank: '',
      hasError: false,
      isPosting: false
    }
  },
  methods: {
    getRandomInt: function (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    getRandomStatus: function () {
      return 200

      /*
      if (this.getRandomInt(1, 3) === 3) {
        return 300
      }

      return 200
      */
    },
    getRandomRequest: function () {
      return `${this.getRandomStatus()}?sleep=${this.getRandomInt(500, 1500)}`
    },
    bankHandler: function () {
      // console.log('Bank handler', this.bank)
      if (this.bank !== '') {
        // console.log('SET BANK', this.bank)
        this.hasError = false
        this.$store.commit('user/saveBank', this.bank)
      }
    },
    submitPost: function (event) {
      // console.log('Submit post')
      if (this.isPosting) {
        console.log('Is posting already')
        return false
      }

      if (this.bank === '') {
        this.hasError = true
        console.log('NO bank!')
        return false
      }

      if (!this.isPosting && this.bank !== '') {
        let request = this.getRandomRequest()
        console.log('Submit post init', request)
        this.isPosting = true

        const result = {
          id: this.$store.state.user.id,
          bank: this.$store.state.user.bank,
          submissionType: this.$store.state.user.submissionType
        }

        // HTTP.post('200?sleep=500', result)
        // HTTP.post('Efaktura/Submit', result)
        HTTP.post(process.env.NODE_ENV === 'production' ? 'Efaktura/Submit' : request, result)
          .then(response => {
            this.hasError = false
            // this.isPosting = false
            // console.log(response.status)
            console.log('Form, redirect to Thanks on success')
            this.$store.commit('progress/completed', true)
            this.$router.push({ name: 'Thanks' })
          })
          .catch(e => {
            // console.log('error', e)
            this.hasError = true
            console.log('Form, redirect to Helpdesk due to bad request')
            this.$router.push({ name: 'Helpdesk' })
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/views/Start/components/Form.vue